import { render, staticRenderFns } from "./cookies_list.vue?vue&type=template&id=3152dfaf"
import script from "./cookies_list.vue?vue&type=script&lang=js"
export * from "./cookies_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports